import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "react-apollo";
import {
  GetTasks as GetTasksGenerated,
  GetTasksVariables as GetTasksVariablesGenerated,
  GetTasks_taskConnections_tasks as TaskDataGenerated,
} from "core/queries/__generated__/GetTasks";

// Queries
export interface TaskData extends TaskDataGenerated {}
export interface GetTasksResponse extends GetTasksGenerated {}
export interface GetTasksVariables extends GetTasksVariablesGenerated {}
export const getTasks = gql`
  query GetTasks(
    $limit: Int
    $cursor: String = "0"
    $filter: TaskFilterInput
    $sort: [TaskSortInput!]
  ) {
    taskConnections(
      limit: $limit
      cursor: $cursor
      filter: $filter
      sort: $sort
    ) {
      total
      cursor
      hasMore
      tasks {
        id
        name
        type
        asanaUrl
        assignee {
          id
          firstName
          lastName
          email
        }
        assignees {
          id
          firstName
          lastName
          email
        }
        cleaningRequest {
          id
          company {
            id
          }
        }
        city {
          id
        }
        cufSpace {
          id
          internalRef
        }
        dueAt
        duringStay
        priority
        unit {
          id
          shortInternalRef
          bookingInfo {
            upcomingBooking {
              id
              checkInTime
            }
          }
          checkInCheckOutInfo {
            isVacantAllDayToday
            checkInToday {
              id
              checkInTime
              checkOutTime
              account {
                id
              }
            }
            checkOutToday {
              id
              checkOutTime
              account {
                id
              }
            }
            occupiedByToday {
              id
              checkOutTime
              account {
                id
              }
            }
          }
        }
        scheduledStartAt
        status
        subjectType
        building {
          id
          shortInternalRef
        }
        completedAt
        createdAt
        taskFeedItemConnections {
          unreadCount
        }
        tomTaskRecurrenceSetting {
          id
          daysOfWeek
          intervalAmt
          intervalUnit
          threadId
        }
      }
    }
  }
`;

export const getTasksQuery = (
  options: QueryHookOptions<GetTasksResponse, GetTasksVariables>,
) => {
  return useQuery<GetTasksResponse, GetTasksVariables>(getTasks, {
    ...options,
  });
};
